import { api } from '@/global/api'

export interface GetExperimentVariantArgs {
  userId?: string
  namespace: string
  keys: Array<string>
}

export interface GetExperimentVariantResponse {
  userId: string
  namespace: string
  features: [
    {
      key: string
      value: string
    }
  ]
}

export const getExperimentVariant = async ({
  userId,
  namespace,
  keys
}: GetExperimentVariantArgs) => {
  const session = userId ? `&session=${userId}` : ''
  const { data } = await api.get(
    `/features?namespace=${namespace.toUpperCase()}&keys=${keys}${session}`
  )
  return data as GetExperimentVariantResponse
}
